import { GeoLocationPoint, Location } from 'model';

export function openInfoWindow(cluster: GeoLocationPoint<Location>, mapInstance: google.maps.Map) {
  const [longitude, latitude] = cluster.geometry.coordinates;
  const { cluster: isCluster } = cluster.properties;

  let title = '';
  cluster.properties.locations.forEach((loc, i) => {
    title += `<a href="/unit/${loc.id}">${loc.nickname}${(i + 1) < cluster.properties.locations.length ? ', ': ''}</a>`;
  });

  const addressData = !isCluster ? `<div><strong>Address: </strong><span>${cluster.properties.address}</span></div>` : '';

  const content = `
    <div class="info-content">
      <h3 style="font-size: 15px">${title}</h3>
      <div class="body-map-content">
        ${addressData}
        <div><strong>City: </strong><span>${cluster.properties.city}</span></div>
        <div><strong>State: </strong><span>${cluster.properties.state}</span></div>
      </div>
    </div>
  `;

  const infowindow = new google.maps.InfoWindow({
    content,
    position: {lat: latitude, lng: longitude}
  });

  infowindow.open(mapInstance);
}
